import React from 'react'
import { InElementSlot } from 'uiComponents/navigation/sectionTabsSlot'
import './tableHeaderSlot.scss'

export const SETTINGS_TABLE_HEADER_SLOT_ID = 'settings-table-header'

interface InSettingsTableHeaderProps {
    children: React.ReactNode
}

export function InSettingsTableHeader({ children }: InSettingsTableHeaderProps) {
    return <InElementSlot slotId={SETTINGS_TABLE_HEADER_SLOT_ID}>{children}</InElementSlot>
}

export default InSettingsTableHeader
